import { DownButton } from 'src/components/MigrateFeed/styles';
import Icon from 'src/components/common/Icon';
import Loading from 'src/components/common/Loading/Loading';
import Table from 'src/components/common/tables';
import { TableHeader } from 'src/components/common/tables/TableHeader';
import { basicInformation } from 'src/apis/migrateSummary';
import { TableRow } from 'src/components/common/tables/TableRow';
import { TableCell } from 'src/components/common/tables/TableCell';
import { Button } from '@habitech/call-to-action';
import { useAppSelector } from 'src/hooks/redux';

interface IColumHeader {
	key: string;
	label: string;
	action?: string;
	value?: string
}

export const COLUMNS_HEADER: IColumHeader[] = [
	{ key: 'total', label: 'Total Inventario', action: 'all', value: 'allPropertiesCount' },
	{ key: 'active', label: 'Total de propiedades activas', action: 'active', value: 'activePropertiesCount' },
	{ key: 'inactive', label: 'Total de propiedades inactivas', action: 'deactivate', value: 'deactivatePropertiesCount' },
	{ key: 'nearTo15', label: 'Total de propiedades a vencer 15 días', action: 'due15Days', value: 'due15DaysPropertiesCount' },
	{ key: 'nearTo30', label: 'Total de propiedades a vencer 30 días', action: 'due30Days', value: 'due30DaysPropertiesCount' }
];

const PropertiesSummary = ({
	summary,
	columnsHeader = COLUMNS_HEADER,
	loadingSummary,
	handleExtend15Days,
	handleExtend30Days,
	email,
	emailContactSummary=null,
	activeTab=null
}) => {

	let summaryData = []; 
	let summaryKey = 0;
	let userSummary;
	
	const { summary: unbanSummary } = useAppSelector((state) => state.unbanUser);
	const { loading: unbanUserloading } = useAppSelector((state) => state.unbanUser);
	let loading = loadingSummary || unbanUserloading;

	const downloadDataMapper = {
		active: summary?.data?.activeProperties,
		all: summary?.data?.allProperties,
		deactivate: summary?.data?.deactivateProperties,
		due30Days: summary?.data?.due30DaysProperties,
		due15Days: summary?.data?.due15DaysProperties
	}


	const downloadReport = async (type: string) => {
		if (summary) {
			const properties = downloadDataMapper[type];
			const propertyIds = properties.join(",");
			basicInformation(propertyIds, email).then((res) => {
				if (res.errors.code === 200) {
					const rows = res.data
					let csvContent = 'data:text/csv;charset=utf-8,';
					rows.forEach((row) => {
						const csvRow = [row.id, row.city, row.colony, row.state].join(",")
						csvContent += csvRow + '\r\n';
					});
					const encodedUri = encodeURI(csvContent);
					const link = document.createElement('a');
					link.setAttribute('href', encodedUri);
					link.setAttribute('download', `reporte-${type}.csv`);
					document.body.appendChild(link);
					link.click();
				}
			})
		}

	};	

	const formatSummaryData = (summary) => {
		let data = [];

		// Check if the summary object is not empty and order by the columns header and check that is a object
		if (summary && typeof summary.data === 'object') {
			data.push(summary.data);
		}

		// Check if the summary. data is an array
		if (summary && Array.isArray(summary.data)) {
			data = summary.data;
		}
		return data;
	}

    switch (activeTab) {
        case 3:
            userSummary = summary;
            break;
        case 5:
            userSummary = emailContactSummary;
            break;
        case 6:
            userSummary = {data: unbanSummary};
            break;
        default:
            userSummary = summary;
            break;
    }
    summaryData = formatSummaryData(userSummary);

	return (
		<Table>
			<thead>
				{
					columnsHeader.map((column, index_column) => (
						<TableHeader key={`column-${column.key}-${index_column}`}>{column.label}
							{
								column.action &&
								<DownButton onClick={() => downloadReport(column.action)}>
									<Icon size={24} icon="pcom-icon-circle-arrow-outline-down" />
								</DownButton>
							}
						</TableHeader>
					))
				}
			</thead>

			{
				loading ? (
					<Loading height="80%" />
				) : (
					<>
						{
							summary &&

							<tbody>
								{
									summaryData.length === 0 && (
										<TableRow>
											<TableCell>No se encontraron resultados</TableCell>
										</TableRow>
									)
								}
								{
									summaryData.length > 0 && (
										summaryData.map((data, index_row) => {
											summaryKey++;
											return (
											<TableRow key={`row-${summaryKey}`}>
												{
													columnsHeader.map((column, index) => (
														<TableCell key={`cell-${column.key}-${index_row}-${index}`}>
															{data[column.value]}
														</TableCell>
													))
												}
											</TableRow>
										)})
									)
								}
								{
									userSummary?.data?.due15DaysPropertiesCount || userSummary?.data?.due30DaysPropertiesCount ? (

										<TableRow>
											<TableCell><></></TableCell>
											<TableCell><></></TableCell>
											<TableCell><></></TableCell>
											<TableCell>
												{
													userSummary?.data?.due15DaysPropertiesCount ? (
														<Button dataId="button-extend-15" originType="pcom" size="small" variant="stroke" fluid onClick={handleExtend15Days}>
															Expandir Vigencia
														</Button>
													) : (<></>)
												}
											</TableCell>
											<TableCell>
												{
													userSummary?.data?.due30DaysPropertiesCount ? (
														<Button dataId="button-extend-30" originType="pcom" size="small" variant="stroke" fluid onClick={handleExtend30Days}>
															Expandir Vigencia
														</Button>
													) : (<></>)
												}
											</TableCell>
										</TableRow>
									) : (<></>)
								}
							</tbody>

						}

					</>
				)
			}
		</Table>
	)
}

export default PropertiesSummary;